// extracted by mini-css-extract-plugin
module.exports = {"partner":"partner-preview_partner__lQZLV","image":"partner-preview_image__PjSRV","content":"partner-preview_content__Hwjrr"};